var React = require('react');

function Technology (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M37.5694 0H7.43164L30.5514 18.6269L37.5694 0Z","fill":"#24CC85","key":0}),React.createElement("path",{"d":"M7.43116 0L0 12.0273L22.5 40L30.5509 18.6269L7.43116 0Z","fill":"#D4F9EC","key":1}),React.createElement("path",{"d":"M37.5689 0L30.5509 18.6269L22.5 40L45.0001 12.0273L37.5689 0Z","fill":"#0E8F59","key":2})]);
}

Technology.defaultProps = {"width":"45","height":"40","viewBox":"0 0 45 40","fill":"none"};

module.exports = Technology;

Technology.default = Technology;
